import { apiProductNatures } from '@spo/services/api';
import {
  DeleteApiSpoSportProductNatureBody,
  SpoDeleteSportNatureResponse,
} from '@spo/types';
import { useMutation } from '@tanstack/react-query';

export const useDeleteSportNature = (
  deleteApiSpoSportProductNatureBody: DeleteApiSpoSportProductNatureBody,
  onSuccess: (responseStatus: SpoDeleteSportNatureResponse) => void,
) => {
  return useMutation({
    mutationKey: ['useDeleteSportNature', deleteApiSpoSportProductNatureBody],
    mutationFn: () =>
      apiProductNatures.deleteProductNature<SpoDeleteSportNatureResponse>(
        deleteApiSpoSportProductNatureBody,
      ),
    onSuccess,
  });
};
